import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"
import { FormInputCardStack } from "../../../../-components/__CLEANUP/_form-card"
import { PrimaryButton } from "../../../../-components/Buttons"
import { FormButtonGroup } from "../../../../-components/form-button-group"
import { Page } from "../../../../-components/Page"
import { Form } from "../../../../-components/typed-form"
import { AbsentApprovalConfig } from "../../../../@client/Theasoft_Absences_Config"
import { AbsenceConfigFormInputs } from "./-components/shared-form-inputs"

export const Route = createFileRoute("/app/admin-settings/absences/new")({
  component: Component,
})

function Component() {
  const navigate = Route.useNavigate()
  const { t } = useTranslation("app_server")

  return (
    <Page>
      <Form<AbsentApprovalConfig, "/api/LeaveRequestConfig/Create">
        url="/api/LeaveRequestConfig/Create"
        initialValues={{
          name: "",
          admins: [],
          nodes: [],
          edges: [],
          modules: [],
          reasons: [],
          timeAccountInfo: { enabled: true },
          availableToContractTypes: [],
          generalApproverSettings: {
            showDutyRoster: false,
          },
          requestFormSettings: {
            showDutyRoster: false,
            descriptionField: {
              isRequired: false,
              label: "",
              placeholder: "",
              description: "",
            },
          },
        }}
        transform={(values) => ({
          data: values,
        })}
        options={{
          onSuccess: (result) => {
            navigate({
              to: "/app/admin-settings/absences/$id",
              params: { id: result.toString() },
            })
          },
        }}
      >
        {(f, _, m) => (
          <FormInputCardStack>
            <AbsenceConfigFormInputs f={f} _={_} />
            <FormButtonGroup>
              <PrimaryButton
                loading={m.isPending}
                className="btn-primary"
                type="submit"
                color={m.isSuccess ? "green" : undefined}
              >
                {t("Create")}
              </PrimaryButton>
            </FormButtonGroup>
          </FormInputCardStack>
        )}
      </Form>
    </Page>
  )
}
